
import { Grid } from "@mui/material";
import { useQuery } from "react-query";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";
import axiosClient from "../../../../../../lib/axios";
import { IDetalharAgronomo } from "../../../../../../types/api/receituarioAgronomico/detalhar-agronomo";
import CardDadosGerais from "./CardDadosGerais";
import CardListaCertificados from "./CardListaCertificados";
import { ConfirmProvider } from "material-ui-confirm";

export default function DialogDetalheAgronomo({
    open,
    value,
    handleClose
}: DialogDetalheAgronomoProps) {

    //querys e mutations
    const { data, isLoading } = useQuery({
        queryKey: [`detalhar-agronomo/${value}`, value],
        queryFn: () => axiosClient.get("/receituario-agronomico/detalhar-agronomo", {
            params: { agronomo_id: value }
        }),
        cacheTime: 0
    });
    const detalhe: TDataQuery = data?.data || null

    return (
        <DialogFullScreen
            {...{ open, handleClose }}
            title="Detalhe do agrônomo"
        >
            {isLoading && <LoadingApiQuery />}

            {
                (!isLoading && detalhe) &&
                <>
                    <Grid container spacing={2}>
                        <Grid  container size={{xs: 12, md: 4}}spacing={2} alignSelf="flex-start">
                            <Grid size={{xs: 12}}>
                                <CardDadosGerais data={detalhe} />
                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, md: 8}} spacing={2} alignSelf="flex-start">
                            <Grid size={{xs: 12}}>
                                <ConfirmProvider defaultOptions={{
                                    title: 'Excluir item',
                                    cancellationText: "Cancelar",
                                    confirmationText: "Excluir",
                                    confirmationButtonProps: { variant: 'contained', color: 'error' }
                                }}>

                                    <CardListaCertificados
                                        data={detalhe}
                                    />
                                </ConfirmProvider>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                {/* <CardItens
                                   data={detalhe}
                                /> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            }

        </DialogFullScreen>
    )
}

interface DialogDetalheAgronomoProps {
    open: boolean,
    handleClose: () => void,
    value: string
}

export interface CardProps {
    data: IDetalharAgronomo
}

type TDataQuery = IDetalharAgronomo | null